import {
  DisableScroll,
  EnableScroll,
  getFM,
  isPortrait,
  Langs,
} from "../../Utilities/utils";
import SocialLinks from "../SocialLinks";
import React, { Component } from "react";
import { BurgerIcon, MenuIcons } from "./MenuIcons";
import { gsap } from "gsap";
import { LanguageContext } from "../../Utilities/LanguageContext";
import { withRouter } from "react-router";
import { injectIntl } from "react-intl";
import LogoEtermax from "../../Resources/logos/Logo-etermax.svg";
import LogoBGCompleto from "../../Resources/icons/etermax_brand-gamification_white.svg";

class DrawerMenu extends Component<{}> {
  static contextType = LanguageContext;

  constructor(props, context) {
    super(props, context);
    this.state = {
      isOpen: false,
      selectedSection: "home",
    };
    this.burgerAnim = gsap.timeline({
      paused: true,
      ease: "none",
    });
  }

  componentDidMount() {
    this.burgerAnim
      .to(["#burgerTop", "#burgerMid", "#burgerBot"], {
        duration: 0.3,
        top: "50%",
      })
      .to(["#burgerTop", "#burgerMid", "#burgerBot"], {
        rotation: 495,
        duration: 0.5,
      })
      .to("#burgerMid", {
        rotation: 405,
        duration: 0.2,
      })
      .fromTo(
        "#drawerMenu",
        {
          display: "none",
          top: "4vmin",
          right: "4vmin",
          width: "5vmin",
          height: "5vmin",
          borderRadius: "2.5vmin",
        },
        {
          display: "block",
          top: "-25vh",
          right: "-25vw",
          borderRadius: "55vh 55vw",
          width: "150vw",
          height: "150vh",
          duration: 0.8,
        },
        "0"
      )
      .to("#drawerMenu", {
        display: "block",
        top: 0,
        right: 0,
        borderRadius: 0,
        width: "100vw",
        height: "100vh",
        duration: 0.2,
      })
      .fromTo(
        ".menu-container",
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 0.2,
        },
        "-=0.2"
      )
      .fromTo(
        ".top-menu",
        {
          //height: 'calc(var(--isize) + var(--mm)*2%',
          height: 0,
        },
        {
          height: 0,
          borderColor: "red",
          duration: 0.5,
        },
        "0"
      )
      .to(
        ["#bg-logo-X", "#bg-logo"],
        {
          fill: "white",
          color: "white",
          duration: "0.5",
        },
        "0.1"
      )
      .to(
        MenuIcons,
        {
          color: "white",
          boxShadow: "var(--iconShadow) white",
          duration: 0.7,
        },
        "0.2"
      )
      .to(["#to-top-icon", "#contact-icon", "#scroll-icon"], {
        display: "none",
        duration: 0.1,
      });

    if (isPortrait()) {
      this.burgerAnim.to(["#ac", "#at"], {
        display: "flex",
        duration: 0.1,
      });
    }
  }

  componentWillUnmount() {
    if (this.isOpen) {
      EnableScroll();
    }
  }

  openMenu() {
    if (this.isOpen) {
      this.burgerAnim.reverse();
      if (!isPortrait())
        document.getElementsByClassName(
          "logo-icon clickable logo-BG-menu"
        )[0].style.display = "block";
      EnableScroll();
    } else {
      this.burgerAnim.play();
      if (!isPortrait())
        document.getElementsByClassName(
          "logo-icon clickable logo-BG-menu"
        )[0].style.display = "none";
      DisableScroll();
    }

    this.isOpen = !this.isOpen;
  }

  changeLang(lng: string) {
    this.context.changeLanguage(lng);
    EnableScroll();
  }

  selectedLang(lng: string) {
    return this.props.intl.locale === lng ? "selected-language" : "clickable";
  }

  openSection(sec: string) {
    this.openMenu();
    const p = sec === "home" ? "" : sec;
    this.props.history.push(`/${p}`);
  }

  getSection(sec: string) {
    const p = sec === "home" ? "" : sec;
    const pn = this.props.location.pathname ?? "/";
    const isSelected = pn.replace("/", "") === p;
    const cls = isSelected ? " selected" : " clickable";
    let section: any;

    if (isSelected && isPortrait()) {
      section = (
        <div className={"section " + cls}>
          <div className={"section-hyphen"} />
          <span
            style={{ marginLeft: "5vw" }}
            onClick={() => this.openSection(sec)}
          >
            {getFM(`menu_${sec}`)}
          </span>
        </div>
      );
    } else {
      section = (
        <div className={"section " + cls}>
          <span onClick={() => this.openSection(sec)}>
            {getFM(`menu_${sec}`)}
          </span>
        </div>
      );
    }

    return section;
  }

  render() {
    return (
      <>
        <span onClick={() => this.openMenu()}>
          <div
            id={"burger"}
            className="menu-icons-container menu-icon clickable"
          >
            <BurgerIcon className={"burger-icon"} />
          </div>
        </span>
        <div
          id="drawerMenu"
          className={"drawerMenu override-decorator accessibility-img"}
        >
          <div
            className={"logo-icon clickable"}
            onClick={() => (window.location.href = `./`)}
          >
            {!isPortrait() && <img src={LogoBGCompleto} alt={""} />}
          </div>
          <div className={"menu-container"}>
            <div className={"sections"}>
              {this.getSection("home")}
              {this.getSection("services")}
              {this.getSection("contact")}

              <hr />
              <div
                className={"section clickable conoce-mas override-decorator"}
              >
                <span className={"terms-and-conditions"}>Conoce más sobre</span>
                <a
                  href={
                    "https://www.etermax.com?lang=" + this.props.intl.locale
                  }
                >
                  <img src={LogoEtermax} alt={""} />
                </a>
              </div>
            </div>
            <div className="languages">
              {Object.entries(Langs).map((lng) => {
                return (
                  <a
                    key={"lng_" + lng[0]}
                    className={
                      "language accessibility-font " + this.selectedLang(lng[0])
                    }
                    onClick={() => this.changeLang(lng[0])}
                  >
                    <span>{lng[1].txt.toLowerCase()}</span>
                  </a>
                );
              })}
            </div>
            <div
              id={"tac"}
              className={"terms-and-conditions override-decorator"}
            >
              <div className={"left"}>
                <a
                  href={
                    "https://www.etermax.com/terms/?lang=" +
                    this.props.intl.locale +
                    "#introduction-bg"
                  }
                >
                  <span>{getFM("footer_terms_and_conditions")}</span>
                </a>
              </div>
              <div>
                <a
                  href={
                    "https://www.etermax.com/privacy/?lang=" +
                    this.props.intl.locale +
                    "#introduction-bg"
                  }
                >
                  <span>{getFM("footer_privacy_policy")}</span>
                </a>
              </div>
              <SocialLinks bColor={"white"} bgColor={"transparent"} />
            </div>
            <div
              id={"brand-email"}
              className={"terms-and-conditions brand-email"}
            >
              <a href={"mailto:brandgamification@etermax.com"}>
                brandgamification@etermax.com
              </a>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(injectIntl(DrawerMenu));
